import React, { PureComponent } from "react";
import { UISref } from "@uirouter/react";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { DefaultRowCell } from "./../../Layout/SortedList";
import { formatAddress } from "../../../helpers/addressHelpers";
import DisplayFullDataButton from "../../Layout/SortedList/DisplayFullDataButton";

class ListRow extends PureComponent {
  static propTypes = {
    isFullDataDisplayed: PropTypes.bool,
    isMobile: PropTypes.bool,
    item: PropTypes.object,
    onDisplayFullData: PropTypes.func
  };

  static defaultProps = {
    isFullDataDisplayed: false,
    isMobile: false,
    item: {},
    onDisplayFullData: null
  };

  state = {
    hasOverflowedChild: false
  };

  handleOverflowedChildState = () => {
    this.setState({
      hasOverflowedChild: true
    });
  };

  render() {
    const { isFullDataDisplayed, isMobile, onDisplayFullData } = this.props;
    const { customerAddress = {}, customerName, customerId, customerTypeValue, id } = this.props.item;
    const { hasOverflowedChild } = this.state;
    return (
      <UISref to="CustomerPurchaseOrders" params={{ customerId: id }}>
        <div role="row" tabIndex="0" className={classNames("sorted-list__row --clickable", isFullDataDisplayed && "--full-data-displayed")}>
          <DefaultRowCell
            className="--first --x5"
            header={isMobile ? i18n.t("customer.name") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={customerName}
          />
          <DefaultRowCell
            className="--x2"
            header={isMobile ? i18n.t("customer.addressBook") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={customerId}
          />
          <DefaultRowCell
            className="--x2"
            header={isMobile ? i18n.t("customer.type") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={customerTypeValue}
          />
          <DefaultRowCell
            className="--x7"
            header={isMobile ? i18n.t("customer.address") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={formatAddress(customerAddress)}
          />
          <DefaultRowCell
            className="--x2"
            header={isMobile ? i18n.t("address.province") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={customerAddress.province}
          />
          <DefaultRowCell
            className="--x2"
            header={isMobile ? i18n.t("address.country") : ""}
            onOverflowedChild={this.handleOverflowedChildState}
            value={customerAddress.country}
          />
          {isMobile &&
            hasOverflowedChild && <DisplayFullDataButton isFullDataDisplayed={isFullDataDisplayed} onDisplayFullData={onDisplayFullData} />}
        </div>
      </UISref>
    );
  }
}

export default ListRow;



// WEBPACK FOOTER //
// ./src/components/Customer/List/ListRow.js